// UUID Generator Utility
// Generates RFC4122 version 4 compliant UUIDs for client-side sale identification

/**
 * Generate a UUID v4 (random)
 * @returns {String} - UUID string in format xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
 */
export function generateUUID() {
    // Use crypto.randomUUID if available (modern browsers)
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    
    // Fallback to manual generation
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

/**
 * Validate if a string is a valid UUID v4
 * @param {String} uuid - String to validate
 * @returns {Boolean} - True if valid UUID v4
 */
export function isValidUUID(uuid) {
    const uuidV4Regex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return uuidV4Regex.test(uuid);
}

/**
 * Generate a short UUID (first 8 characters) for display purposes
 * @returns {String} - Short UUID string
 */
export function generateShortUUID() {
    return generateUUID().split('-')[0];
}

/**
 * Install UUID generator on window object for global access
 */
export function installGlobalUUID() {
    if (typeof window !== 'undefined') {
        window.generateUUID = generateUUID;
    }
}

// Auto-install on import if in browser environment
if (typeof window !== 'undefined' && !window.generateUUID) {
    installGlobalUUID();
}

export default {
    generateUUID,
    isValidUUID,
    generateShortUUID,
    installGlobalUUID
};
